import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPatientBedGraph = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.375 15.75C6.375 16.2473 6.57254 16.7242 6.92417 17.0758C7.27581 17.4275 7.75272 17.625 8.25 17.625C8.74728 17.625 9.22419 17.4275 9.57582 17.0758C9.92746 16.7242 10.125 16.2473 10.125 15.75C10.125 15.2527 9.92746 14.7758 9.57582 14.4242C9.22419 14.0725 8.74728 13.875 8.25 13.875C7.75272 13.875 7.27581 14.0725 6.92417 14.4242C6.57254 14.7758 6.375 15.2527 6.375 15.75V15.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.875H19.0833C19.5254 13.875 19.9493 14.0506 20.2618 14.3632C20.5744 14.6757 20.75 15.0996 20.75 15.5417V17.625H12V13.875Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 17.625H20.75V20.125H3.25V17.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 21.375V13.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.75 21.375V20.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 2.625H18.25V10.125H5.75V2.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 6.37499H8.54083C8.64372 6.37498 8.74502 6.34957 8.83573 6.30102C8.92644 6.25246 9.00376 6.18227 9.06083 6.09666L9.7025 5.13416C9.75378 5.05686 9.82162 4.99195 9.9011 4.94413C9.98058 4.89631 10.0697 4.86678 10.162 4.85769C10.2543 4.84859 10.3475 4.86016 10.4348 4.89154C10.5221 4.92293 10.6013 4.97336 10.6667 5.03916L13.4333 7.80832C13.4913 7.86638 13.5602 7.91243 13.6359 7.94385C13.7117 7.97528 13.793 7.99145 13.875 7.99145C13.957 7.99145 14.0383 7.97528 14.1141 7.94385C14.1898 7.91243 14.2587 7.86638 14.3167 7.80832L15.5667 6.55832C15.684 6.44095 15.8432 6.375 16.0092 6.37499H18.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPatientBedGraph.displayName = 'SvgPatientBedGraph';
export default SvgPatientBedGraph;
